<div class="row modal-bar">

  <div class="col-sm-6">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>

  <div class="col-sm-6">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>

</div>

<form class="form-content">
  <div class="section-wrapper mg-t-20">

    <div class="tab-content-wrapper">

      <t4-tabs class="details-tabs" (selected)="loadTabDetails($event)">
        @for (ticketType of this.availableTicketTypes(); track ticketType; let i = $index) {
          <t4-tab class="tab-pane-content" [pos]="i.toString()" [selected]="i === 0" tabTitle="{{ getTicketTypeTabelLabel(ticketType) }}">
              <app-seat-plan class="tab-pane-content-seat-plan" [ticketType]="ticketType"
                [eventIds]="this.selectedEventIds"
                [section]="this.selectedSellableSection"
                [passePartouts] = "this.selectedPassePartouts"
                [orderlineSelection] = "this.selectedOrderLines"
              (onSelectionChange)="onPlacementSelectionChange($event, ticketType.Id)"></app-seat-plan>
          </t4-tab>
        }
        <t4-tab tabTitle="SALES.ORDERS.NEW.SALES-SECTION-SELECTION.DIALOG.DETAILS.TAB.UNPLACED" selected="false">
          <div class="mg-t-20 tab-pane-content">
            <!-- a single tab for all unplaced -->
            <app-sales-unplaced-ticket-selection
              [events]="this.selectedEventIds"
              [passePartouts] = "this.selectedPassePartouts"
              [section]="this.selectedSellableSection"
              [orderlineSelection] = "this.selectedOrderLines"
              (onSelectionChange)="onUnplacementSelectionChange($event)"
            #unplacedTicketSelection></app-sales-unplaced-ticket-selection>
          </div>
        </t4-tab>
      </t4-tabs>

    </div>

    <div class="row mt-3 footer-actions">
      <div class="col-lg-8"></div>
      <div class="col-lg-2"> <button  [disabled]="selectionIsEmpty" (click)="submit()" class="btn btn-block btn-primary bd-0"><i class="far fa-save"></i> {{ 'GENERIC.BUTTON.ADDNEW' | translate}}</button></div>
      <div class="col-lg-2"><button (click)="dialogRef.close(false)" class="btn btn-block btn-secondary bd-0"><i class="fas fa-ban"></i> {{ 'GENERIC.BUTTON.CANCEL' | translate }}</button></div>




    </div>


  </div>

</form>
